const stats = [
  { value: '+50', label: 'Membres accompagnés' },
  { value: '+7 ans', label: "d'expérience en Bourse" },
  { value: '+4,9★', label: 'de note moyenne' },
];

const AboutSection = () => (
  <section className="bg-[#F5F0FF] py-16 px-8 lg:px-16">
    <div className="max-w-[1272px] mx-auto flex flex-col lg:flex-row items-center gap-12">
      {/* Left content */}
      <div className="flex-1 max-w-[580px]">
        <div className="inline-block bg-[#1E0750] text-[#A3E635] text-xs font-bold px-3 py-1.5 rounded-full mb-5 tracking-widest uppercase">
          Mon Histoire
        </div>
        <h2 className="text-[#1E0750] font-black text-3xl lg:text-4xl mb-5 leading-tight">
          Pourquoi je te l&apos;apprends<br />
          <span className="text-[#7B35ED]">mieux que personne ?</span>
        </h2>
        <div className="text-[#1E0750]/70 text-sm leading-relaxed space-y-4 mb-8">
          <p>
            J&apos;ai commencé à investir en Bourse comme beaucoup : sans méthode, en perdant de l&apos;argent sur des conseils glanés ici et là. Puis j&apos;ai décidé de me former sérieusement et de développer ma propre stratégie.
          </p>
          <p>
            Après des années de tests, d&apos;erreurs et d&apos;apprentissages, j&apos;ai créé la <strong className="text-[#1E0750]">Méthode LS INVEST</strong> — une approche simple, reproductible, et accessible à tous, quel que soit ton niveau de départ.
          </p>
          <p>
            Aujourd&apos;hui, j&apos;ai accompagné plus de 300 personnes à construire leur indépendance financière. C&apos;est maintenant ton tour.
          </p>
        </div>
        {/* Stats */}
        <div className="grid grid-cols-3 gap-4">
          {stats.map((s, i) => (
            <div key={i} className="bg-white border border-[#E2D9F3] rounded-xl p-4 text-center">
              <div className="text-[#7B35ED] font-black text-xl mb-1">{s.value}</div>
              <div className="text-[#1E0750]/60 text-xs leading-tight">{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Right image */}
      <div className="flex-shrink-0 w-full lg:w-[440px] h-[380px] rounded-2xl overflow-hidden border border-[#E2D9F3]">
        <img
          src="https://public.readdy.ai/ai/img_res/7a7fd39e911f7824af378dbe8f65cea3.jpg"
          alt="LS INVEST"
          className="w-full h-full object-cover object-top"
        />
      </div>
    </div>
  </section>
);

export default AboutSection;
